// Sort events so the upcoming-this-week night appears first.
// Given today is Thursday → order becomes: Thu, Fri, Sat, Sun (×n), Mon, Tue, Wed.
// Falls back to original order if an event has no day_of_week.

const DAY_INDEX = {
  Sunday: 0,
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6,
};

export function sortEventsByUpcomingDay(events, now = new Date()) {
  if (!Array.isArray(events) || events.length === 0) return events;
  const today = now.getDay(); // 0..6, Sunday = 0
  return [...events].sort((a, b) => {
    const da = DAY_INDEX[a?.day_of_week];
    const db = DAY_INDEX[b?.day_of_week];
    if (da == null && db == null) return 0;
    if (da == null) return 1;
    if (db == null) return -1;
    // Days until that weekday (0 if today, 1 if tomorrow, ..., 6 if a week away)
    const distA = (da - today + 7) % 7;
    const distB = (db - today + 7) % 7;
    if (distA !== distB) return distA - distB;
    // Same weekday — keep stable order by existing sort_order/date
    return 0;
  });
}
